var _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompassPurple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "120.834px",
    height: "109.667px",
    viewBox: "0 0 120.834 109.667",
    enableBackground: "new 0 0 120.834 109.667",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Kontakt",
    display: "none"
  }, /*#__PURE__*/React.createElement("polygon", {
    display: "inline",
    fill: "none",
    stroke: "#280A3C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: " 114.826,13.698 3.17,44.97 37.242,59.967 46.579,94.076 52.548,67.588 93.278,90.809  "
  }), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "none",
    stroke: "#280A3C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: " M114.826,13.698L37.242,59.967L114.826,13.698z"
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#280A3C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x1: 52.548,
    y1: 67.586,
    x2: 114.826,
    y2: 13.698
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#280A3C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x1: 46.579,
    y1: 94.076,
    x2: 63.208,
    y2: 73.793
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Schulung",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#280A3C",
    strokeWidth: 2.2517,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M106.928,54.887c0,24.404-19.784,44.189-44.189,44.189c-24.406,0-44.19-19.785-44.19-44.189c0-24.404,19.784-44.189,44.19-44.189 C87.144,10.698,106.928,30.483,106.928,54.887z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#280A3C",
    d: "M91.627,63.518c-0.003,0-0.006,0-0.009,0L39.6,63.945c-0.618,0.004-1.117,0.508-1.117,1.125v14.041 c0,0.623,0.504,1.127,1.126,1.127h36.989c0.291,0,0.571-0.113,0.781-0.314l15.029-14.469c0.332-0.32,0.436-0.811,0.261-1.236 C92.496,63.793,92.084,63.518,91.627,63.518z M76.144,77.986H40.734V66.188l48.075-0.395L76.144,77.986z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#280A3C",
    d: "M72.198,75.572c2.092,0,3.793-1.658,3.793-3.695s-1.701-3.693-3.793-3.693 c-2.093,0-3.796,1.656-3.796,3.693S70.105,75.572,72.198,75.572z M72.198,70.436c0.85,0,1.541,0.646,1.541,1.441 s-0.691,1.443-1.541,1.443c-0.852,0-1.544-0.648-1.544-1.443S71.347,70.436,72.198,70.436z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#280A3C",
    d: "M94.01,58.139L57.286,22.783c-0.327-0.313-0.81-0.402-1.222-0.225c-0.416,0.177-0.686,0.585-0.686,1.036 v36.468c0,0.305,0.123,0.596,0.342,0.809c0.211,0.203,0.492,0.318,0.784,0.318c0.012,0,0.022,0,0.034-0.002l36.724-1.113 c0.453-0.014,0.854-0.297,1.017-0.719C94.442,58.932,94.336,58.453,94.01,58.139z M57.631,58.902V26.241l32.89,31.666 L57.631,58.902z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#280A3C",
    d: "M52.194,60.062V35.75c0-0.516-0.35-0.965-0.85-1.092c-0.497-0.122-1.021,0.103-1.267,0.556L36.915,59.527 c-0.188,0.348-0.18,0.771,0.023,1.111c0.202,0.342,0.57,0.551,0.967,0.551h13.163C51.69,61.189,52.194,60.686,52.194,60.062z  M49.942,58.938H39.795l10.147-18.743V58.938z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Projektmanagement"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#280A3C",
    d: "M62.737,9.518c-24.987,0-45.315,20.329-45.315,45.316c0,24.986,20.328,45.316,45.315,45.316 s45.316-20.33,45.316-45.316C108.054,29.846,87.725,9.518,62.737,9.518z M62.737,97.898c-23.745,0-43.063-19.318-43.063-43.064 S38.992,11.77,62.737,11.77c23.746,0,43.064,19.318,43.064,43.064S86.483,97.898,62.737,97.898z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#280A3C",
    d: "M62.807,36.238c0.622,0,1.126-0.504,1.126-1.126v-3.243c0-0.622-0.504-1.126-1.126-1.126 s-1.126,0.504-1.126,1.126v3.243C61.681,35.734,62.185,36.238,62.807,36.238z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#280A3C",
    d: "M62.807,72.898c-0.622,0-1.126,0.504-1.126,1.125v3.244c0,0.623,0.504,1.127,1.126,1.127 s1.126-0.504,1.126-1.127v-3.244C63.933,73.402,63.429,72.898,62.807,72.898z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#280A3C",
    d: "M82.264,55.695h3.243c0.622,0,1.126-0.506,1.126-1.127s-0.504-1.125-1.126-1.125h-3.243 c-0.622,0-1.126,0.504-1.126,1.125S81.642,55.695,82.264,55.695z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#280A3C",
    d: "M72.767,42.725c-0.397-0.386-1.018-0.425-1.46-0.093l-11.045,8.281c-0.094,0.07-0.177,0.156-0.244,0.251 l-8.783,12.457c-0.307,0.434-0.268,1.023,0.094,1.414l1.266,1.367c0.221,0.238,0.522,0.361,0.826,0.361 c0.237,0,0.475-0.074,0.677-0.227l12.021-9.045c0.02-0.016,0.031-0.037,0.05-0.053c0.014-0.012,0.032-0.016,0.046-0.029 c0.022-0.021,0.031-0.051,0.052-0.072c0.034-0.039,0.076-0.068,0.104-0.109l7.989-11.654c0.31-0.453,0.249-1.062-0.145-1.445 L72.767,42.725z M53.72,64.004l7.344-10.416l2.696,2.861L53.72,64.004z M65.303,54.803l-2.682-2.846l9.268-6.947l0.076,0.074 L65.303,54.803z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#280A3C",
    d: "M62.807,28.028c-14.603,0-26.483,11.881-26.483,26.485c0,14.602,11.881,26.482,26.483,26.482 c14.604,0,26.485-11.881,26.485-26.482C89.292,39.91,77.411,28.028,62.807,28.028z M62.807,78.744 c-13.361,0-24.231-10.869-24.231-24.23c0-13.362,10.87-24.233,24.231-24.233c13.362,0,24.233,10.871,24.233,24.233 C87.04,67.875,76.169,78.744,62.807,78.744z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#280A3C",
    d: "M43.351,53.443h-3.244c-0.622,0-1.126,0.504-1.126,1.125s0.504,1.127,1.126,1.127h3.244 c0.622,0,1.126-0.506,1.126-1.127S43.973,53.443,43.351,53.443z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Beratung",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#684B94",
    d: "M62.738,9.571c-24.987,0-45.316,20.329-45.316,45.315c0,24.987,20.329,45.316,45.316,45.316 s45.315-20.329,45.315-45.316C108.054,29.9,87.726,9.571,62.738,9.571z M62.738,97.951c-23.746,0-43.064-19.318-43.064-43.064 c0-23.745,19.318-43.063,43.064-43.063c23.745,0,43.063,19.318,43.063,43.063C105.802,78.633,86.483,97.951,62.738,97.951z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#684B94",
    d: "M59.672,62.822c0.321,0.018,0.641,0.026,0.96,0.026c4.203,0,8.206-1.526,11.36-4.353 c3.395-3.041,5.402-7.221,5.652-11.771s-1.287-8.926-4.327-12.321v0c-3.04-3.395-7.22-5.402-11.77-5.653 c-4.552-0.25-8.926,1.287-12.32,4.328c-3.396,3.041-5.402,7.221-5.653,11.771c-0.25,4.549,1.286,8.924,4.326,12.318 C50.94,60.563,55.121,62.571,59.672,62.822z M45.822,44.974c0.218-3.949,1.961-7.578,4.907-10.217 c2.74-2.454,6.215-3.779,9.863-3.779c0.276,0,0.554,0.007,0.831,0.023c3.949,0.217,7.577,1.959,10.216,4.906 c2.64,2.947,3.974,6.745,3.757,10.695c-0.218,3.95-1.96,7.579-4.906,10.217s-6.739,3.982-10.694,3.756 c-3.95-0.219-7.579-1.961-10.218-4.908C46.938,52.721,45.605,48.923,45.822,44.974z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#684B94",
    d: "M76.104,30.394c-0.463,0.415-0.503,1.127-0.088,1.59c3.688,4.117,5.551,9.422,5.248,14.939 c-0.304,5.517-2.738,10.585-6.854,14.272c-3.527,3.158-8.069,5.023-12.789,5.254c-6.258,0.304-12.243-2.198-16.418-6.86 c-0.416-0.464-1.127-0.503-1.59-0.088s-0.503,1.127-0.088,1.59c4.541,5.071,11.006,7.831,17.801,7.623 c-0.083,0.157-0.13,0.335-0.13,0.524v7.465H50.341c-0.622,0-1.126,0.504-1.126,1.125c0,0.622,0.504,1.127,1.126,1.127h23.961 c0.622,0,1.126-0.505,1.126-1.127c0-0.621-0.504-1.125-1.126-1.125H63.448v-7.465c0-0.248-0.08-0.478-0.217-0.664 c4.689-0.541,9.145-2.535,12.681-5.701c4.564-4.089,7.264-9.709,7.601-15.827c0.337-6.117-1.729-12-5.818-16.564 C77.279,30.018,76.566,29.979,76.104,30.394z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompassPurple);
export default __webpack_public_path__ + "static/media/compassPurple.d6d43b0f91f81e3869f8962d7637cd3d.svg";
export { ForwardRef as ReactComponent };